import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { UserPlus } from "lucide-react";

const submitLabel = (busy, mode) => {
  if (busy) return "Saving…";
  return mode === "invite" ? "Send invite" : "Add user";
};

export default function NewUserForm({ mode, form, setForm, busy, onSubmit }) {
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  return (
    <>
      <form onSubmit={onSubmit} className="grid grid-cols-1 md:grid-cols-5 gap-3 items-end">
        <div className="space-y-1.5"><Label>Name</Label>
          <Input data-testid="invite-name" value={form.name} required onChange={set("name")} className="min-h-[44px]" /></div>
        <div className="space-y-1.5"><Label>Email</Label>
          <Input type="email" data-testid="invite-email" value={form.email} required onChange={set("email")} className="min-h-[44px]" /></div>
        <div className="space-y-1.5"><Label>Access level</Label>
          <Select value={form.role} onValueChange={(v) => setForm({ ...form, role: v })}>
            <SelectTrigger data-testid="invite-role" className="min-h-[44px]"><SelectValue /></SelectTrigger>
            <SelectContent>
              <SelectItem value="standard">Standard — add & edit, deletes need approval</SelectItem>
              <SelectItem value="admin">Admin — full access</SelectItem>
            </SelectContent>
          </Select></div>
        {mode === "manual" ? (
          <div className="space-y-1.5"><Label>Password (min 8)</Label>
            <Input type="text" data-testid="manual-password" value={form.password} required minLength={8} onChange={set("password")} className="min-h-[44px] font-mono" /></div>
        ) : <div className="hidden md:block" />}
        <Button type="submit" data-testid="invite-submit" disabled={busy} className="min-h-[44px]">
          <UserPlus className="w-4 h-4 mr-1.5" /> {submitLabel(busy, mode)}
        </Button>
      </form>
      {mode === "manual" && <p className="text-xs text-muted-foreground" data-testid="manual-hint">Share the password with the leader yourself — no email is sent. They can change it later via "Forgot your password?".</p>}
    </>
  );
}
